import { useSearchParams } from "react-router-dom";
import { ArticleFeed } from "./Rubrique";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  return <ArticleFeed key={q} params={{ search: q }} title={`Résultats pour « ${q} »`} testId="search-page" emptyText="Aucun article ne correspond à votre recherche." />;
}
